export default {
  SUPER_ADMIN: 'super-admin',
  SUPER_ADMIN_VIEWER: 'sa-viewer',
}
